import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  applyCurrentRescheduleFilter,
  areRescheduleClassesAppliedFiltersPresentSelector,
  areRescheduleClassesCurrentFiltersPresentSelector,
  resetRescheduleFilters,
  setRescheduleClassesFilterModalState,
} from 'features/classCreation';

function RescheduleClassesFilterDrawerHeader() {
  const dispatch = useDispatch();
  const areAppliedFiltersPresent = useSelector(
    areRescheduleClassesAppliedFiltersPresentSelector
  );
  const areCurrentFiltersPresent = useSelector(
    areRescheduleClassesCurrentFiltersPresentSelector
  );

  const handleModalClose = useCallback(() => {
    dispatch(setRescheduleClassesFilterModalState(false));
  }, [dispatch]);

  const handleResetFilter = useCallback(() => {
    dispatch(resetRescheduleFilters());
  }, [dispatch]);

  const handleApplyFilter = useCallback(() => {
    dispatch(applyCurrentRescheduleFilter());
  }, [dispatch]);

  return (
    <div className="row align-c space-between">
      <div className="m-r-xs bold h3 dark">
        <Icon
          name="arrow-left"
          className="m-r-xxs cursor"
          onClick={handleModalClose}
        />
        back
      </div>
      <div>
        {areAppliedFiltersPresent && (
          <Tappable
            noHighlight
            onClick={handleResetFilter}
            className="primary m-r-xs h5 bold"
          >
            Reset Filters
          </Tappable>
        )}
        <Tappable
          onClick={handleApplyFilter}
          className="btn btn-primary btn-small btn-long bold"
          disabled={!areCurrentFiltersPresent}
        >
          Apply
        </Tappable>
      </div>
    </div>
  );
}

export default RescheduleClassesFilterDrawerHeader;
